import { Field as BaseField, type FieldDescriptionProps } from '@base-ui/react';

import { clsxs } from '~/styles/utils';

import { descriptionStyle } from './RadioDescription.css';

type Props = FieldDescriptionProps;

export const RadioDescription = ({ ...delegated }: Props) => {
  return <BaseField.Description {...delegated} className={clsxs(descriptionStyle, delegated.className)} />;
};
